export default __webpack_public_path__ + "static/media/switch-circle.92ecaf71.svg";